import consumer from "./consumer.js"

consumer.subscriptions.create("FlashMessagesChannel", {
  connected() {
  },

  disconnected() {
  },

  received(data) {
    try {
      // Process the turbo-stream
      const tempContainer = document.createElement('div')
      tempContainer.innerHTML = data.html
      const turboStream = tempContainer.querySelector('turbo-stream')

      if (turboStream) {
        // Process the stream action manually
        const action = turboStream.getAttribute('action')
        const target = turboStream.getAttribute('target')
        const template = turboStream.querySelector('template')

        if (action === 'append' && target && template) {
          const targetElement = document.getElementById(target)
          if (targetElement) {
            // Clone and append the template content
            const clonedContent = template.content.cloneNode(true)
            targetElement.appendChild(clonedContent)
          } else {
            console.error('🔔 Target element not found:', target)
          }
        }
      }
    } catch (error) {
      console.error('🔔 Error processing flash message:', error)
    }
  },
});
